import React from "react";
import { Link, useLocation } from "react-router-dom";
const images = require.context("../assets/images", false);

function Footer() {
  const location = useLocation();
const isHome = location.pathname === "/";
const isAbout = location.pathname === "/about-us";
const tours = location.pathname === "/tours";
const blog = location.pathname === "/blog";
const starhotels = location.pathname === "/5-star-luxury-hotels";
const cardetails = location.pathname === "/car-details";


  return (
    <>
    <div className="whatsapp-float-btn">
    <Link
      to="https://wa.me/919416575716"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src={images("./whatsapp-sm.svg")} />
    </Link>
 
</div>

  <footer className={`footer ${isHome || isAbout || tours || blog || starhotels || cardetails ? "" : "mt-80"}`}>
      <div className="inner-footer">
    <div className="container">
      <div className="row paddingY-70">
        <div className="col-md-4">
          <div className="footer-card color-white">
            <Link to="/"><img src={images("./luxurygoldentrianglelogo.png")} alt="logo" /></Link>
            <p className="footer-logo-description mt-2 mb-4" style={{ color: "#fff" }}>India captivates with its rich culture, ancient heritage and extraordinary diversity. At the heart of it all lies our Luxury Golden Triangle Tour — a bespoke private journey through Delhi, Agra and Jaipur, travelling by private car and staying in heritage palaces and handpicked luxury hotels, with curated extensions into Rajasthan, Varanasi and the wellness retreats of Kerala.</p>

<div className="social-icon">
              <Link to="https://www.facebook.com/LuxuryGoldenTriangleTour" target="_blank">
    <img src={images("./facebook.svg")} alt="facebook" />
  </Link>
  <Link to="https://www.instagram.com/luxurygoldentriangle/" target="_blank">
    <img src={images("./instagram.svg")}  alt="instagram" />
  </Link>
  <Link to="https://www.linkedin.com/in/luxurygoldentriangle/" target="_blank">
    <img src={images("./linkdin.svg")} alt="linkdin" />
  </Link>

  <Link to="https://wa.me/919416575716" target="_blank">
    <img src={images("./whatsapp.svg")} alt="whatsapp" />
  </Link>
</div>

          </div>
        </div>
        <div className="col-md-3">
          <div className="footer-card color-white">
            <h3 className="mb-5">Quick Links</h3>
            <ul>
              <li>
                <Link className="active" to="/5-star-luxury-hotels">
                  5* Hotels List
                </Link>
              </li>
              <li>
               <Link  className="active" to="/car-details">Car Details</Link>
              </li>
              <li>
                <Link className="active" to="/tours">Tours</Link>
              </li>
              <li>
                <Link className="active" to="/luxury-golden-triangle-enquiry">Customize Your Tour</Link>
              </li>
              <li>
                <Link className="active" to="/terms-conditions">Terms & Conditions</Link>
              </li>
              <li>
                <Link className="active" to="/faq">FAQ</Link>
              </li>              
            </ul>
          </div>
        </div>
        
<div className="col-md-5">
  <div className="footer-card color-white">
    <h3 className="footer-contact-title">Contact</h3>


    <div className="footer-contact-box mb-4">
      <p className="footer-contact-address">
        #296, Ground Floor, Chitrakoot, Pitampura, New Delhi,<br />
        India 110034
      </p>
      <div className="footer-contact-row">
        <img src={images("./clock.svg")} alt="" />
        <span>Mon. - Sat. 9AM - 6PM (IST)</span>
      </div>

      <div className="footer-contact-row">
        <img src={images("./mail.svg")} alt="" />
        <Link to="mailto:contact@luxurygoldentriangle.com">
          contact@luxurygoldentriangle.com
        </Link>
      </div>
      <div className="footer-contact-row">
        <img src={images("./arrow-right.svg")} alt="" />
        <Link
          to="https://www.luxurygoldentriangle.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.luxurygoldentriangle.com
        </Link>
      </div>
            <div className="footer-contact-row">
        <img src={images("./phone-call.svg")} alt="" />
        <Link to="tel:+919416575716">+91 9416575716</Link>
      </div>
      <p className="footer-contact-note">
        For ongoing tours, we are available 24 X 7 on above telephone number.
      </p>
    </div>
  </div>
</div>


      </div>
      <div className="footer-bottom-logos">
        <div className="footer-payment-block">
          <h3>Payment Method</h3>
          <div className="payment-list">
            <div className="payment-list-card">
              <img src={images("./card1.svg")} alt="Visa" />
              <img src={images("./card2.svg")} alt="Mastercard" />
              <img src={images("./card3.svg")} alt="Maestro" />
              <img src={images("./card4.svg")} alt="American Express" />
              <img src={images("./card5.svg")} alt="Diners Club" />
            </div>
          </div>
        </div>
        <div className="increadle-ind">
          <img src={images("./foot1.png")} alt="Ministry of Micro, Small and Medium Enterprises Government of India" />
          <img src={images("./foot2.png")} alt="Incredible India approved by Ministry of Tourism Government of India" />
        </div>
      </div>
      <div className="copyright color-white center">
        <p>©Luxury Golden Triangle 2026 (a unit of <Link to="https://www.virsatravels.com/">Virsa Travels</Link>)</p>
      </div>
    </div>
  </div>
</footer>
</>
  );
}

export default Footer;
